import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black text-white border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src="/assets/honex-mark-white.svg"
              alt="Honex GmbH"
              className="h-12 w-auto"
            />
            <p className="mt-6 text-zinc-400 font-light max-w-sm">
              Bauunternehmen aus Essen im Herzen des Ruhrgebiets.
              Hochbau · Tiefbau · Industriebau.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] font-bold uppercase tracking-widest text-red-500 mb-4">
              Navigation
            </div>
            <ul className="space-y-2">
              {[
                ["Leistungen", "#leistungen"],
                ["Über Uns", "#ueber-uns"],
                ["Prozess", "#prozess"],
                ["Kontakt", "#kontakt"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a
                    href={h}
                    data-testid={`footer-link-${l.toLowerCase().replace(/\s|ü/g, "-")}`}
                    className="text-zinc-300 hover:text-red-500 transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] font-bold uppercase tracking-widest text-red-500 mb-4">
              Kontakt
            </div>
            <ul className="space-y-3 text-zinc-300 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-red-500 flex-shrink-0" />
                <span className="whitespace-pre-line">{"Max-Keith-Str. 66\n45136 Essen"}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-red-500 flex-shrink-0" />
                <a href="tel:+4920143355633" className="hover:text-red-500 transition-colors">
                  0201 43355633
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-red-500 flex-shrink-0" />
                <a href="mailto:info@honexbau.de" className="hover:text-red-500 transition-colors">
                  info@honexbau.de
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-zinc-900 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} Honex GmbH. Alle Rechte vorbehalten.</div>
          <div className="flex items-center gap-6">
            <Link to="/impressum" data-testid="footer-impressum" className="hover:text-red-500 transition-colors">Impressum</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-red-500 transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
